import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './assets/App.css';
import "@mui/styles";
import { ThemeProvider, createTheme, Theme } from '@mui/material/styles';


import AdapterMoment from '@mui/lab/AdapterMoment';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

import Footer from './common/Footer';
import Header from './common/Header';

import SnakAlert from './components/SnakAlert';
import ConfirmationDialog from './components/ConfirmationDialog';
import AppInitializer from './AppInitializer';

import Routes from './routes/index';
import WithClearCache from './WithClearCache';
import { useSelector, useDispatch } from "react-redux";

import { datadogRum } from '@datadog/browser-rum';



if (process.env.REACT_APP_DD_APP_ID) {
  datadogRum.init({
    applicationId: process.env.REACT_APP_DD_APP_ID,
    clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN,
    site: 'us5.datadoghq.com',
    service: 'c360',
    env: process.env.REACT_APP_DD_ENV,
    version: process.env.REACT_APP_COMMIT_ID,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
    enableExperimentalFeatures: ['clickmap']
  });
  datadogRum.startSessionReplayRecording();
}


function App() {
  const themeMode = useSelector((state: any) => state.themeMode);
  const [Theme, setTheme] = useState<any | null>(null)

  useEffect(() => {
    let theme = createTheme({
      spacing: 4,
      palette: {
        mode: themeMode
      },
    });

    setTheme(theme)
  }, [themeMode])


  return (
    <div className="app">
      {Theme &&
        <ThemeProvider theme={Theme}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <WithClearCache />

            <AppInitializer>
              <Router>
                <Header />
                <Routes />
                <Footer />
              </Router>
            </AppInitializer>
            <SnakAlert />
            <ConfirmationDialog />
          </LocalizationProvider>
        </ThemeProvider>
      }
    </div>
  );
}

export default App;